import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import Landing from '../pages/landing/page';
import LandingCreate from '../pages/landing/page/create';
import LandingEdit from '../pages/landing/page/edit';
import LandingRead from '../pages/landing/page/read';
import LandingDB from '../pages/landing/db';
import GuestReservation from '../pages/landing/guest-reservation';

const BoardRouter: FC = () => {
  return (
    <Switch>
      <Route path='/landing/page' exact component={Landing} />
      <Route path='/landing/page/create' exact component={LandingCreate} />
      <Route path='/landing/page/:landingCode' exact component={LandingRead} />
      <Route path='/landing/page/:landingCode/edit' exact component={LandingEdit} />
      <Route path='/landing/db' exact component={LandingDB} />
      <Route path='/landing/guest-reservation' exact component={GuestReservation} />
    </Switch>
  )
}

export default BoardRouter;
